import { useState, useEffect } from "react";
import VendorDetails from "./VendorDetails";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation, faCircleCheck, faCircleMinus, faSpinner } from "@fortawesome/free-solid-svg-icons";

function VendorsList(props) {
  const vendors = props;
  const [showVendorDetails, setShowVendorDetails] = useState(false);
  const [openVendorDetails, setOpenVendorDetails] = useState(false);
  const [vendorSubscription, setVendorSubscription] = useState(
    vendors.vendor.subscription_status
  );

  const warningEnabled = vendors.vendor.settings?.warningEnabled;
  const healthWarning = vendors.vendor.warning_status;

  const axiosPrivate = useAxiosPrivate();
  const controller = new AbortController();

  const isInactiveOrDisabled = ['INACTIVE', 'DISABLED'].includes(vendors.vendor.subscription_status);

  const formatDate = (dateString) => {
    const options = {
      year: "numeric",
      month: "numeric",
      day: "numeric"
    };
    return new Date(dateString).toLocaleDateString("sl-SI", options);
  };

  const vendorUpdate = async (vendorId, payload, prevSubscription) => {
    try {
      const response = await axiosPrivate.patch(
        `updateVendor?vendorId=${vendorId}`,
        payload,
        {
          signal: controller.signal,
        }
      );
      setVendorSubscription(payload.subscriptionStatus);
    } catch (err) {
      console.error(err);
      setVendorSubscription(prevSubscription);
    }
  };

  const onSubscriptionTypeChange = (e) => {
    let prevSubscription = vendorSubscription;
    let payload = {
      subscriptionStatus: e.target.value,
    };

    vendorUpdate(vendors.vendor.id, payload, prevSubscription);
  };

  const displayLanguages = (languages) => {
    if (!languages || languages.length === 0) {
      return "Vendor nima izbranih jezikov";
    }

    return languages.length > 1 ? languages.join(", ") : languages[0];
  };

  return (
    <div>
      <div className={"prcVendor" + (showVendorDetails ? " prcVendorOpen" : "")} style={{ backgroundColor: isInactiveOrDisabled ? "#F6F6F6" : "#fff" }} >
        <div
          className="row mb-2 mt-2 prcRowClick"
          onClick={(e) => setShowVendorDetails(!showVendorDetails)}
        >
          <div className="col-md-1 prcVendorImgWrap">

            {vendors.vendor.logo_url && (
              <img
                src={`${process.env.REACT_APP_SUPERADMIN_IMAGES_HOST}${vendors.vendor.logo_url}`}
                alt="review"
              />
            )}
          </div>
          <div className="col-md-3 prcVendorName">
            <span className="hideDesktop">Podjetje: </span>
            {vendors.vendor.name}
          </div>
          <div className="col-md-1 prcVendorName">
            <span className="hideDesktop">Jeziki: </span>
            {displayLanguages(vendors.vendor.languages)}
          </div>
          <div className="col-md-1 prcVendorSubscription">
            <span className="hideDesktop">Offline url: </span>
            {vendors.vendor.invoice_invite_settings !== null &&
              vendors.vendor.invoice_invite_settings.enabled ? (
              <span>{vendors.vendor.invoice_invite_settings.url}</span>
            ) : (
              <span>&nbsp;</span>
            )}
          </div>

          <div className="col-md-1 prcVendorSubscription">
            <span className="hideDesktop">Naročnina: </span>
            <select
              onChange={(e) => onSubscriptionTypeChange(e)}
              value={vendorSubscription}
              onClick={(e) => e.stopPropagation()}
            >
              <option value="BASIC">BASIC</option>
              <option value="TRIAL">TRIAL</option>
              <option value="INACTIVE">INACTIVE</option>
              <option value="DISABLED">DISABLED</option>
            </select>
          </div>
          <div className="col-md-2 prcVendorCreated">
            <p className="small">
              {Object.entries(vendors.vendor.services).map(([serviceName, serviceDetails], index) => (
                <div>{serviceName}: {serviceDetails?.type || 'N/A'}</div>
              ))}
            </p>
          </div>

          <div className="col-md-1 prcVendorCreated">
            <span className="hideDesktop">Ustvarjeno: </span>
            <time dateTime="DD.MM.YYYY, hh:mm">
              {formatDate(vendors.vendor.created)}
            </time>
          </div>


          <div className="col-md-1 prcVendorCreated d-flex align-items-center justify-content-center">
            {/* OPOZORILO: Ikone za opozorilo */}
            {healthWarning === 'loading' ? (
              <div>
                <FontAwesomeIcon icon={faSpinner} spin style={{ color: "#aaa", fontSize: "1.25em" }} title="Nalagam status..." />
              </div>
            ) : !warningEnabled ? (
              <div>
                <FontAwesomeIcon icon={faCircleMinus} style={{ color: "#ccc", fontSize: "1.25em" }} title="Preverjanje izklopljeno" />
              </div>
            ) : healthWarning === true ? (
              <div>
                <FontAwesomeIcon icon={faTriangleExclamation} style={{ color: "red", fontSize: "1.25em" }} title="Opozorilo: Pošiljanje je podpovprečno glede na nastavljeno obdobje" />
              </div>
            ) : (
              <div>
                <FontAwesomeIcon icon={faCircleCheck} style={{ color: "green", fontSize: "1.25em" }} title="Stanje pošiljanja je OK" />
              </div>
            )}
          </div>
        </div>
        {showVendorDetails && (
          <div className="row">
            <div className="col-md-12">
              <VendorDetails vendor={vendors.vendor} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default VendorsList;
